import styled from '@emotion/styled';

import theme from '@app/styles/theme';
import { screenMedium, screenSmall } from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

const Table = styled.table<{ alternateRows?: boolean }>`
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  border-spacing: 0;

  & th,
  & td {
    padding: ${rem(10)};

    @media screen and (max-width: ${screenSmall}) {
      font-size: ${rem(14)};
    }

    @media screen and (min-width: ${screenMedium}) {
      padding: ${rem(20)};
    }
  }

  & th {
    border-bottom: 1px solid ${theme.colors.lightGray};
  }

  & thead {
    font-weight: 600;
    text-align: left;
  }

  & tbody {
    & tr {
      &:nth-of-type(2n + 1) {
        background-color: ${({ alternateRows = true }) =>
          alternateRows ? theme.colors.whiteSecondary : 'initial'};
      }

      &:last-of-type td,
      &:last-of-type th {
        border-bottom: 0;
      }
    }
  }
`;

export default Table;
